module.exports = "https://cdn.redage.net/src/views/player/documets/msc/images/logo.png";